
const { createClaimFormSuccess, createClaimFormFailure, getClaimFormSuccess, getClaimFormFailure, updateClaimFormSuccess, updateClaimFormFailure, sortClaimSuccess, sortClaimFailure, viewClaimFormSuccess, viewClaimFormFailure, createClaimLinkSuccess, createClaimLinkFailed, viewClaimLinkSuccess, viewClaimLinkFailed, submitClaimLinkSuccess, submitClaimLinkFailed, customerPolicyClaimSuccess, customerPolicyClaimFailed, customerPolicyLOBSuccess, customerPolicyLOBFailed } = require("./action")
const { CREATE_CLAIMFORM_START, GET_CLAIMFORM_START, UPDATE_CLAIMFORM_START, SORT_CLAIMFORM_START, VIEW_CLAIMFORM_START, CREATE_CLAIM_LINK, VIEW_CLAIM_LINK, SUBMIT_CLAIM_LINK, CUSTOMER_POLICY_CLAIM, CUSTOMER_POLICY_LOB } = require("./actiontypes")
const { createClaimFormAPI, getClaimAPI, updateClaimAPI, sortclaimAPI, viewClaimFormAPI, createClaimLinkAPI, viewClaimLinkAPI, submitClaimLinkAPI, customerPolicyClaimAPI, customerPolicyLOB } = require("./api")
import { takeEvery, fork, put, all, call } from "redux-saga/effects"



function* createClaimsAsync(action) {
  try {
    const response = yield call(createClaimFormAPI, action.payload)
    if (response.status === 201) {
      yield put(createClaimFormSuccess(response.data))
      console.log(response)
    } else {
      yield put(createClaimFormFailure(error.response.data))
    }
  } catch (error) {
    yield put(createClaimFormFailure(error.response.data))
    console.log(error)
  }
}
function* createClaim() {
  yield takeEvery(CREATE_CLAIMFORM_START, createClaimsAsync)
}




function* getClaimAsync(action) {
  try {
    const response = yield call(getClaimAPI, action.payload)
    if (response.status === 200) {
      yield put(getClaimFormSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getClaimFormFailure(error.response.data.message))
  }
}

function* GetClaim() {
  yield takeEvery(GET_CLAIMFORM_START, getClaimAsync)
}



function* updateClaimAsync(action) {
  try {
    const response = yield call(updateClaimAPI, action.payload)
    if (response.status === 200) {
      yield put(updateClaimFormSuccess(response.data))
    } else {
      yield put(createClaimFormFailure(error.response.data))
    }
  } catch (error) {
    yield put(updateClaimFormFailure(error.response.data))
  }
}

function* updateClaim() {
  yield takeEvery(UPDATE_CLAIMFORM_START, updateClaimAsync)
}



function* sortClaimAsync(action) {
  try {
    const response = yield call(sortclaimAPI, action.payload)
    if (response.status === 200 || 201) {

      yield put(sortClaimSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(sortClaimFailure(error.response.data))
  }
}

function* sortClaim() {
  yield takeEvery(SORT_CLAIMFORM_START, sortClaimAsync)
}

function* viewClaimFormAsync(action) {
  try {
    const response = yield call(viewClaimFormAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(viewClaimFormSuccess(response.data.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(viewClaimFormFailure(error.response.data.message))
  }
}

function* viewClaimForm() {
  yield takeEvery(VIEW_CLAIMFORM_START, viewClaimFormAsync)
}



function* createClaimLinkAsync(action) {
  try {
    const response = yield call(createClaimLinkAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(createClaimLinkSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(createClaimLinkFailed(error.response.data.message))
  }
}

function* createClaimLink() {
  yield takeEvery(CREATE_CLAIM_LINK, createClaimLinkAsync)
}


function* viewClaimLinkAsync(action) {
  try {
    const response = yield call(viewClaimLinkAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(viewClaimLinkSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(viewClaimLinkFailed(error?.response?.data?.message || "Something unexpected error occured, please try again"))
  }
}

function* viewClaimLink() {
  yield takeEvery(VIEW_CLAIM_LINK, viewClaimLinkAsync)
}



function* submitClaimLinkAsync(action) {
  try {
    const response = yield call(submitClaimLinkAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(submitClaimLinkSuccess(response.data.message))
    } else {
      throw response
    }
  } catch (error) {
    yield put(submitClaimLinkFailed(error?.response?.data?.message || "Something unexpected error occured, please try again"))
  }
}

function* submitClaimLink() {
  yield takeEvery(SUBMIT_CLAIM_LINK, submitClaimLinkAsync)
}

function* customerPolicyClaimAsync(action) {
  try {
    const response = yield call(customerPolicyClaimAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(customerPolicyClaimSuccess(response?.data?.data||[]))
    } else {
      throw response
    }
  } catch (error) {
    yield put(customerPolicyClaimFailed(error?.response?.data?.message || "Something unexpected error occured, please try again"))
  }
}

function* customerPolicyClaim() {
  yield takeEvery(CUSTOMER_POLICY_CLAIM, customerPolicyClaimAsync)
}


function* customerPolicyLOBAsync(action) {
  try {
    const response = yield call(customerPolicyLOB, action.payload) // <-- calls API fn
    if (response.status === 200 || response.status === 201) {
      yield put(customerPolicyLOBSuccess(response?.data?.data || []))
    } else {
      throw response
    }
  } catch (error) {
    yield put(customerPolicyLOBFailed(error?.response?.data?.message || "Something unexpected error occured, please try again"))
  }
}

// ✅ rename the watcher to avoid clashing with the imported API fn
function* customerPolicyLOBWatcher() {
  yield takeEvery(CUSTOMER_POLICY_LOB, customerPolicyLOBAsync)
}

function* ClaimSaga() {
  yield all([
    fork(createClaim),
    fork(GetClaim),
    fork(updateClaim),
    fork(sortClaim),
    fork(viewClaimForm),
    fork(createClaimLink),
    fork(viewClaimLink),
    fork(submitClaimLink),
    fork(customerPolicyClaim),
    fork(customerPolicyLOBWatcher), // ✅ updated here
  ])
}

export default ClaimSaga
